import { holodeckStateDefaults } from './data.holodeck';

export const defaults = {
  holodeckState: holodeckStateDefaults,
};
